import React, { useState }from 'react'
import {Link} from 'react-router-dom'
import { Button,Modal } from 'react-bootstrap';
import styled from 'styled-components'
import Detail from '../../../components/detail/Detail'
import 'bootstrap/dist/css/bootstrap.min.css';

const Container =styled.div`
    display : flex;
    flex-direction: column;
    background: #0c0c0c;
    height: 800px;
    justify-content: center;
    text-align: center;
    @media screen and (max-width:860px){
        height: 1500px;
    }
`
const MyLink = styled(Link)`
    margin:0 1rem;
    font-size : 21px;
    padding: 0.1rem 0;
    width: 120px;
    color: white;
    cursor: pointer;
    text-decoration: none;
    list-style: none;
    line-height : 29.3px;
    &:hover{
        background: #53D825;
        text-decoration: none;
    list-style: none;
    color: white;
    font-size : 21px;
    }
`
const Portofolio = () => {
    
    const menu =[
        {
            id : 1,
            name : "Klinik Nurazizah",
            katagori : "wordpress",
            link:"http://kliniknurazizah.epizy.com/",
            describe : "Profile Compay using Wordpress",
            image : require("../../../image/klinik.png")
        },
        {
                id : 2,
                name : "Kanban Board",
                katagori : "react",
                link : "https://mykanbanboard.netlify.app/",
                describe : "A List Create by React, React-Context, SCSS. etc ",
                image : require("../../../image/kanban.png")
        },
        {
                id : 3,
                name : "Admin Teknik Informatika",
                katagori:"php",
                link:"http://islahtugas.rf.gd/?i=1",
                describe : "Login multiuser create using Bootstrap and PHP mySqli",
                image : require("../../../image/multi.png")
        },
        {
            id : 4,
            name : "NonaBakes",
            katagori: "all",
            describe : "Profile Company create using Bootstrap",
            link : "https://github.com/islahola/nonabakes.git",
            image :require("../../../image/nona.png")
        },
        {
            id : 5,
            name : "My Cashier",
            katagori:"react",
            link:"https://github.com/islahola/mycashier.git",
            describe : "Profile Company create using Bootstrap",
            image :require("../../../image/casir.png")
        },
        {
            id : 6,
            name : "Pemilu",
            katagori: "php",
            link : "https://github.com/islahola/projek-pemilu.git",
            describe : "Profile Company create using Codenigter",
            image :require("../../../image/pemilu.png")
        }
    ]
    const [skills,setSkils]= useState(menu)
    
     const React = (catagItem) =>{
        const updateItems = menu.filter((item) =>{
            return item.katagori ===catagItem;
        });
        return setSkils(updateItems)
     }

    return (
              <Container id="portofolio">
                  <h1 style={h1}>Portofolio</h1>
                  <ul style={nav}>
                      <MyLink onClick={()=>setSkils(menu)}>All</MyLink>
                      <MyLink onClick={() => React('php')}>PHP</MyLink>
                      <MyLink onClick={() => React('react')} >React</MyLink>
                      <MyLink onClick={()=> React('wordpress')}>Wordpress</MyLink>
                      
                  </ul>
                  <div style={containerGambar}>
                    {skills.map (item =>
                        <div key ={item.id} style={card}>
                            <img src={item.image.default}  style={gambar} alt ={item.name}/>
                            <Link style={{textDecoration:"none", color:"#000"}} >
                                <Detail data={item}/>
                            </Link>
                        </div>    
                    )}
                </div>
                <div>
                   
                </div>
                </Container>
    )
}

export default Portofolio
const h1={
    color: '#01bf71',
    width: '42px',
    marginLeft: '16%',
    borderBottom:'3px solid #fff'

}
const nav = {
    display : "flex",
    height: "80px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
}
const containerGambar ={
    display : "flex",
    flexWrap: "wrap",
    padding: "0 6rem",
    justifyContent: 'center',
}
const card ={
    width: "327px",
    padding: "1.5rem 2rem",
    height: "199px"
}
const gambar = {
    width :"100%",
    height:"100%"
}